<mat-dialog-content>
    <div class="modal-header d-flex align-items-center justify-content-end">
        <button type="button" #closebutton class="close btn-close" [mat-dialog-close]="false" data-dismiss="modal"> <i
          class="fa-solid fa-xmark"></i></button>
    </div>
    <div class="verification-modal">
        <mat-icon class="verified-icon d-block" [ngClass]="fontIcon === 'check_circle_outlined' ? 'text-success' : 'text-danger'" aria-hidden="false" aria-label="Example home icon" [fontIcon]="fontIcon">

        </mat-icon>

        @if(fontIcon === 'check_circle_outlined'){
        <h3>{{title | translate }}</h3>
        }@else if(fontIcon == "report_gmailerrorred"){
        <h3 class="text-danger">{{title | translate }}</h3>
        <p>4 {{'ATTEMPTS' | translate }},<span class="text-danger">{{'FAILED' | translate}}!</span></p>
        }@else {
        <h3 class="text-danger">{{title | translate }}</h3>
        }
        <h4>{{Description | translate }}</h4>
        <button *ngIf="!IsApproval" mat-flat-button color="primary" class="my-3 px-5" (click)="close()">{{'OK' | translate }}</button>
        <button *ngIf="IsApproval" mat-flat-button class="deal-btn ms-3 px-5 py-1" color="primary" (click)="close()">
            {{'YES' | translate }}
        </button>
        <button *ngIf="IsApproval" mat-flat-button color="warn" class="deal-btn ms-3 px-5 py-1" [mat-dialog-close]="false" data-dismiss="modal">
            {{'NO' | translate }}
        </button>
         
        <!-- <button *ngIf="IsApproval" mat-flat-button color="primary" class="my-3 px-5" (click)="close()">Yes</button>
        <button *ngIf="IsApproval" mat-flat-button color="warn" class="my-3 px-5" [mat-dialog-close]="false" data-dismiss="modal">No</button> -->
    </div>
</mat-dialog-content>